import type { LocationQuery } from 'vue-router';

import { parsePlainDate } from '@shared/lib/date-time';

/**
 * Плоское представление query-параметров роутера: массивы сворачиваются к первому
 * значению, null/undefined-ключи отбрасываются. Общий парсер URL-состояния
 * фильтров/страниц (clients, orders и т.п.) — единый источник вместо локальных копий.
 */
export const queryToRecord = (query: LocationQuery): Record<string, string> => {
  const out: Record<string, string> = {};

  for (const [key, raw] of Object.entries(query)) {
    if (raw == null) {
      continue;
    }

    out[key] = Array.isArray(raw) ? (raw[0] ?? '') : raw;
  }

  return out;
};

/** URL-состояние без пустых значений: пустая строка — ключа в адресе нет. */
export const compactQuery = (record: Record<string, string>): Record<string, string> =>
  Object.fromEntries(Object.entries(record).filter(([, value]) => value !== ''));

/** Дата `YYYY-MM-DD` из URL или `undefined`, если её нет или она не разбирается. */
export const plainDateParam = (value: string | undefined): string | undefined =>
  value && parsePlainDate(value) !== null ? value : undefined;
